import React, {Component} from 'react';
import TextField from '../../lib/mdb/text-field';
import CheckboxField from '../../lib/mdb/checkbox-field.js';


import {
    initPopover
} from "../../lib/payment-method-util"
import {mapMessages} from "../../lib/utils";
import DoNotSaveField from "./do-not-save-field";

/**
 *  This component renders fields for the e-check payment method.
 */
class PaymentMethodPDFields extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    render() {
        const {state} = this.props,
            {config} = state,
            {messages, paymentConfig} = config;
        let msgList = mapMessages(messages, "opp.pdAgreement.msg", 5);
        return (
            <React.Fragment>
                <div className="col-12 PD-field">
                    <div className="pm-logo-row debit-logos">
                        <span className="cc-dc-title">{messages["payment.debit.network.label"]}</span>
                        <img className="logo-star" src={messages["opp.image.pm.star"] || "images/pm/star.png"} alt="STAR"/>
                        <img className="logo-nyce" src={messages["opp.image.pm.nyce"] || "images/pm/nyce.png"} alt="NYCE"/>
                        <img className="logo-pulse" src={messages["opp.image.pm.pulse"] || "images/pm/pulse.png"}
                             alt="Pulse"/>
                    </div>
                </div>
                <div className="col-md-6 col-12 PD-field">
                    <TextField
                        key="paymentMethod-accountNumber"
                        name="paymentMethod.accountNumber"
                        placeholder={messages["opp.cardNumber.tip"]}
                        description={messages["payment.cardNumber.label"]}
                        maxLength="16"
                        className="md-form form-group"
                        labelClass="bootstrap-label"
                        aria-required="true"
                        validations={{
                            required: messages["opp.validation.cardNumber.required"],
                            numeric: messages["opp.validation.cardNumber.invalid"]
                        }}
                        autoComplete="off"/>
                </div>
                <div className="col-12 PD-field">
                    <a href="#" data-toggle="modal" data-target="#modal-pd-agreement"
                       data-backdrop="static">{messages["payment.pinless.agreement.label"]}</a>
                    <div className="form-group m-0">
                        <CheckboxField
                            key="paymentMethod-acceptPinlessDebitPaymentAgreement"
                            name="paymentMethod.acceptPinlessDebitPaymentAgreement"
                            description={messages["payment.pinless.agreement.accept"]}
                            className="form-check pl-0"
                            inputClass="form-check-input"
                            labelClass="form-check-label"
                            aria-required="true"
                            validations={{
                                required: messages["opp.validation.customerAuthorization.required"]
                            }}
                        />
                    </div>
                </div>
                <div className="modal mdb-modal fade" id="modal-pd-agreement" tabIndex="-1" role="dialog"
                     aria-labelledby="modal-pd-agreement" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="modal-pd-agreement">
                                    {messages["opp.pdAgreement.title"]}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true"><i className="material-icons">&#xE5CD;</i></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12">
                                        {msgList.map((msg, index) => {
                                            if (index === 0) return (
                                                <p key={"pd-msg-" + index}><b key={"pd-msgb-" + index}>{msg}</b></p>);
                                            return (<p key={"pd-msg-" + index}>{msg}</p>);
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn btn-primary" data-dismiss="modal">
                                    {messages["closeButton.label"]}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                { (paymentConfig && paymentConfig.cpDoNotSavePmEnabled === 'true') &&
                    (
                        <div className="col-12 order-5">
                            <DoNotSaveField messages={messages} />
                        </div>
                    )
                }
            </React.Fragment>
        );
    };
}

export default PaymentMethodPDFields